import { Component, OnInit, ViewChild, AfterViewInit, OnDestroy } from "@angular/core";
import { BaseChartDirective } from "ng2-charts";
import { Router, RouterModule } from "@angular/router";
import { DatePipe, CommonModule, TitleCasePipe } from "@angular/common";
import { APIURL } from "app/Shared/Constant/API_Urls";
import { HttpErrorResponse } from "@angular/common/http";
import { UrlsService } from "app/Shared/Services/urls.service";
import { UserService } from "app/Shared/Services/user.service";
import { SharedHttpClientService } from "app/Shared/Services/shared-http-client.service";
import { EmitterService } from "app/Shared/Services/emitter.service";
import { map, Subscription } from "rxjs";
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSort, MatSortModule } from "@angular/material/sort";
import { MatPaginator, MatPaginatorModule } from "@angular/material/paginator";
import { MatCardModule } from "@angular/material/card";
import { MatTableDataSource, MatTableModule } from "@angular/material/table";
import { MatTooltipModule } from "@angular/material/tooltip";
import { ChartConfiguration } from "chart.js";

@Component({
    selector: 'app-cat-finra-submission-feedback',
    imports: [MatSortModule, MatPaginatorModule, MatCardModule, MatTableModule, MatTooltipModule, MatProgressSpinnerModule,
       CommonModule, DatePipe, TitleCasePipe, RouterModule, BaseChartDirective
    ],
    templateUrl: './cat-finra-submission-feedback.component.html',
    styleUrls: ['./cat-finra-submission-feedback.component.scss']
})
export class CatFinraSubmissionFeedbackComponent implements OnInit,AfterViewInit, OnDestroy {
  JsonData!: Object;
  Totalcount!: number;
  todate!: Date;// = new Date();
  @ViewChild(BaseChartDirective) chart: BaseChartDirective | any;
  @ViewChild(MatSort) sort: MatSort | any;
  @ViewChild(MatPaginator) paginator: MatPaginator | any;
  isLoadingResults!: boolean;
  isRateLimitReached = false;
  displayedColumns = ["Reject_Code", "Rejects"];
  dataset: any = [];
  LastCATExecutionDate: any;
  Label = "FINRACAT";
  totalExceptions = 0;
  dataSource = new MatTableDataSource();
  public redirectUrl: any = "true";
  rowcount: number = 50;
  subscription!: Subscription;
  public barChartOptions: any = {
    scaleShowVerticalLines: false,
    responsive: true,
    scaleShowValues: true,
    scaleValuePaddingX: 0,
    scaleValuePaddingY: 0,
    barPercentage: 0.5,
    plugins: {
      colors: {
        enabled: true
      },
      datalabels: { 
       display: false
      },
      legend: {
        position: 'top',
        display: false
      }
    },
   
    scales: {
      y: {
        //display: false,
        //scaleLabel:{ display: true, labelString: 'Exception Count'},
        ticks: {
          beginAtZero: true,
          maxTicksLimit: 5,
          stepSize: 1,
          //max : 1000,
          //min: 0,
          // Create Numberic notation labels
          callback: function (value:any, index:any, values:any) {

            if (value >= 1000 && value < 1000000) {
              value = value / 1000 + ' K';
            }
            if (value >= 1000000) {
              value = value / 1000000 + ' M';
            }
            return value
            }
        }
      }
      ,
      x: {
        display: true,
        categoryPercentage: 0.7,
        barPercentage: 0.5,
        scrollbar: {
          enabled: true
        }
      }
    },
    tooltips: {
      enabled: true,
      backgroundColor: 'Black',
      textColor: 'black',
      opacity: 1
    },
    animations: {
      tension: {
        duration: 100,
        easing: 'linear',
        from: 1,
        to: 0,
        loop: true
      }
    }
  };
  public ChartData: any = [0,0,0,0,0];
  public barChartLabels: string[] = ["No data","No data","No data","No data","No data"];
  public barChartType: string = 'bar';
  //   //public barChartLegend: boolean = true;
  public chartColors: any[] = [
    { backgroundColor: "#0288D1" }];
  public barChartData: any[] = [
    {
      data: this.ChartData, label: 'Open', backgroundColor: '#0288D1'
    }
  ];

  public chartData: ChartConfiguration<'bar'>['data'] = {
    labels: this.barChartLabels,
    datasets: this.barChartData
  }

  constructor(
    private router: Router,
    private UrlsService: UrlsService,
    public UserService: UserService,
    private SharedHttpClientService: SharedHttpClientService,
    private EmitterService: EmitterService,
    public date:DatePipe) {
      this.LastCATExecutionDate=null;

  }
  ngOnInit() {
    /*** Get Last CAT Execution date*/
    this.LastCATExecutionDate = this.UserService.CATLastFinraSubmitDate;
    if(this.LastCATExecutionDate){
   this.subscription = this.EmitterService.reloadMainDashBoard.subscribe(value => {
      if (value) {
        this.isLoadingResults = true;
        this.UserService.get_CAT_Last_ReportDate().subscribe((res: any) => {
          let response: any = res;
          let jsondata = response.data[0]
          if(jsondata) {
            this.LastCATExecutionDate = jsondata.FinraSubmitLastExecutionReportDate !=="" ? this.UserService.getFormatedDate(jsondata.FinraSubmitLastExecutionReportDate) : new Date();
            this.get_FINRA_Submission_ExceptionCount('FINRACAT', this.LastCATExecutionDate);
          }
        });
      }
    });
  }
  }
  ngAfterViewInit() {
    this.get_FINRA_Submission_ExceptionCount(this.Label, this.LastCATExecutionDate)
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }
  get_FINRA_Submission_ExceptionCount(Label:any, FinraDate:any) {
    if (FinraDate !== "" && FinraDate !== null) {
      this.Label = Label;
      this.isLoadingResults = true;
      this.SharedHttpClientService.get(
        this.UrlsService.setAPIURl1(
          APIURL.CAT_Dash_Pre_Validation,
          this.UserService.getActiveMPID() + "/" + Label + "/" +this.UserService.getyyyyMMddDateFormate(FinraDate)))
        .pipe(map((response: Response) => {
          this.isLoadingResults = false;
          return response;
        }))
        .subscribe({
            next: (Element: any) => {
              if (Element == null) {
                Element = [{ Reject_Code: "No data", Errors: "0", Exception_Description: "No Data" }];
                this.dataSource.data = Element
              } else {
                for (let i = 0; i < Element.length; i++) {
                  // this.dataset.push({ Reject_Code: Element[i].exception_Code, Rejects: Element[i].count, Exception_Description: Element[i].exception_Description })
                  this.totalExceptions = this.totalExceptions + Element[i].count;
                  if (i < 5) {//inserted top 6 values only
                    this.barChartLabels[i]=(Element[i].exception_Code);
                    this.ChartData[i]=(Element[i].count);
                    this.dataset[i]=({ Reject_Code: Element[i].exception_Code, Rejects: Element[i].count, Exception_Description: Element[i].exception_Description }) 
                  }
                }
              }
              //   Element.push({ count: "0", exception_Code: "0012", exception_Description: "CAT Exception" })
              this.dataSource.data = this.dataset;
              this.chartData = {
                labels: this.barChartLabels,
                datasets: this.barChartData
              }
              this.isLoadingResults = false;
            },    
            error: (err: HttpErrorResponse) => {
              this.isLoadingResults = false;
              this.isRateLimitReached = true;
            }
        });    
    }
  }
 
  setMenu(code: any) {
    this.EmitterService.setActiveMenu.emit({ MenuId: 0, MenuName: 'CAT', SubMenuName: 'Finra-Exception', exceptionCode: code, page: 'CAT' });
  }

  Route(code: any) {
    this.redirectUrl = '/pages/CAT/Finra-Exception/' + this.UserService.getyyyyMMddDateFormate(this.LastCATExecutionDate) + '/' + code;
  }

  ngOnDestroy() {
    if(this.subscription)
    this.subscription.unsubscribe();
  }
}
